
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

const QuestionsGrid = ({ 
  questionsData, 
  questionsLoading, 
  selectedQuestions, 
  handleQuestionToggle,
  questionPage,
  setQuestionPage 
}) => {
  return (
    <div className="flex-1 flex flex-col">
      <div className="flex-1 overflow-hidden">
        {questionsLoading ? (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-primary"></div>
          </div>
        ) : questionsData?.data?.questions?.length > 0 ? (
          <div className="h-full flex flex-col">
            <ScrollArea className="flex-1">
              <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {questionsData.data.questions.map((question) => (
                    <Card key={question._id} className="p-4 hover:shadow-md transition-shadow">
                      <div className="flex items-start space-x-3">
                        <Checkbox
                          checked={selectedQuestions.some((q) => q._id === question._id)}
                          onCheckedChange={() => handleQuestionToggle(question)}
                          className="mt-1"
                        />
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium line-clamp-3 mb-3">
                            {question.question}
                          </p>
                          <div className="flex flex-wrap gap-2 mb-2">
                            <Badge variant="outline" className="text-xs">
                              {question.category}
                            </Badge>
                            {question.subCategory && (
                              <Badge variant="outline" className="text-xs">
                                {question.subCategory}
                              </Badge>
                            )}
                            <Badge 
                              variant="outline" 
                              className={`text-xs ${
                                question.difficultyLevel === 'easy' ? 'bg-green-100 text-green-800' :
                                question.difficultyLevel === 'medium' ? 'bg-yellow-100 text-yellow-800' :
                                'bg-red-100 text-red-800'
                              }`}
                            >
                              {question.difficultyLevel}
                            </Badge>
                            <Badge variant="secondary" className="text-xs">
                              {question.qtyp?.replace("_", " ")}
                            </Badge>
                          </div>
                          <div className="text-xs text-gray-500 text-right">
                            {question.value} points
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </div>
            </ScrollArea>

            {questionsData?.data?.totalPages > 1 && (
              <div className="border-t p-4 flex-shrink-0">
                <Pagination>
                  <PaginationContent>
                    <PaginationItem>
                      <PaginationPrevious
                        onClick={() => setQuestionPage((p) => Math.max(p - 1, 1))}
                        disabled={questionPage === 1}
                        className={
                          questionPage === 1
                            ? "pointer-events-none opacity-50"
                            : "cursor-pointer"
                        }
                      />
                    </PaginationItem>
                   {(() => {
    const totalPages = questionsData.data.totalPages;
    const current = questionPage;
    let start = Math.max(1, current - 2);
    let end = Math.min(totalPages, current + 2);

    if (end - start < 4) {
      if (start === 1) {
        end = Math.min(5, totalPages);
      } else if (end === totalPages) {
        start = Math.max(1, totalPages - 4);
      }
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(
        <PaginationItem key={i}>
          <PaginationLink
            isActive={questionPage === i}
            onClick={() => setQuestionPage(i)}
            className="cursor-pointer"
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
    return pages;
  })()}

                    <PaginationItem>
                      <PaginationNext
                        onClick={() =>
                          setQuestionPage((p) =>
                            Math.min(p + 1, questionsData.data.totalPages)
                          )
                        }
                        disabled={questionPage === questionsData.data.totalPages}
                        className={
                          questionPage === questionsData.data.totalPages
                            ? "pointer-events-none opacity-50"
                            : "cursor-pointer"
                        }
                      />
                    </PaginationItem>
                  </PaginationContent>
                </Pagination>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-12 text-gray-500">
            <p className="text-lg">No questions found matching your criteria</p>
            <p className="text-sm mt-2">Try adjusting your filters to see more results</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionsGrid;